// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"a92aed69","673":"f576b4f1"}[chunkId] + ".chunk.js";
};